import React from 'react';
import '../../styles/AsSeenOn.css';

function AsSeenOn() {
  // Example data for logos and their links
  const mediaLogos = [
    { id: 1, image: 'logo6.png', link: 'https://sg.finance.yahoo.com/news/unveiling-prime-investment-opportunities-iconic-020000460.html' },
    { id: 2, image: 'logo8.png', link: 'https://www.prnewswire.com/apac/news-releases/property-portal-mogul-names-simon-yio-as-new-managing-director-301788506.html' },
    
    { id: 4, image: 'logo5.png', link: 'https://www.zaobao.com.sg/news/singapore/story20240309-3131250?fbclid=IwAR0udlM-Koqe0CWSHUKIyIthsgTlaLFsCUzDGhJe0yQSKhwY12EMhB-zqEs' },
    { id: 5, image: 'logo4.png', link: 'https://www.itbiznews.com/news/articleView.html?idxno=144104' },
    
    { id: 6, image: 'logo9.png', link: '' },
    { id: 7, image: 'logo2.png', link: 'https://www.edgeprop.sg/property-news/simon-yio-leading-coaching-and-never-giving' },
    { id: 3, image: 'logo3.png', link: 'https://www.channelnewsasia.com/singapore/national-crisis-portal-homeowners-emergency-listing-4181326' },
    { id: 8, image: 'logo7.png', link: 'https://www.straitstimes.com/singapore/housing/s-poreans-who-helped-stranded-malaysians-amid-covid-19-welcome-emergency-housing-portal' },
    { id: 9, image: 'logo1.png', link: 'https://www.facebook.com/CNA938/photos/a.207255705997715/4403013869755190/?type=3' },
    { id: 10, image: 'logo10.png', link: '' },
  ];

  const gridItems = [...mediaLogos]; // Add null placeholders for empty cells

  return (
    <section className='asSeenOn'>
      <h1>As Seen On</h1>
      <div className='mediaLogos'>
        {gridItems.map((logo, index) =>
            <a key={logo.id} href={logo.link} target='_blank' rel='noopener noreferrer'>
              <img src={require(`../../assets/Logos/${logo.image}`)} alt={`Media Logo ${logo.id}`} />
            </a>
        )}
      </div>
    </section>
  );
  }
  
export default AsSeenOn;